import React, { useEffect, useRef } from "react";
// import { Prompt } from "react-router";
// import UUID from "../../common/utilities/Uuid";
// import cacheService from "../../services/cache-service/CacheService";

import { useBlocker } from "react-router";

export type HasChangesCallback = () => boolean;
export type GetUserConfirmationCallback = () => Promise<boolean>;

export type UnsavedChangesPromptProps = {
    hasChanges: boolean | HasChangesCallback;
    getUserConfirmation: GetUserConfirmationCallback;
};

export default function UnsavedChangesPrompt({ hasChanges, getUserConfirmation }: UnsavedChangesPromptProps) {

    // const uuid = useRef<string>(UUID.generate());
    // const cacheKey = `confirm-${uuid.current}`;

    const blocker = useBlocker(hasChanges);
    const funcRef = useRef<GetUserConfirmationCallback>(getUserConfirmation);

    useEffect(() => {

        if (blocker.state === "blocked") {
            _getUserConfirmation();
        }

        async function _getUserConfirmation() {
            const canContinue = await funcRef.current();
    
            if(canContinue) {
                blocker.proceed && blocker.proceed();
            } else {
                blocker.reset && blocker.reset();
            }
        }

    }, [
        blocker
    ]);

    // useEffect(() => {
    //     cacheService.set(cacheKey, getUserConfirmation);

    //     return () => {
    //         cacheService.delete(cacheKey);
    //     };
    // }, [getUserConfirmation, cacheKey]);

    return (
        <></>
    );
}


